import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, isRef as _isRef, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Administrators")
], -1)
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = {
  key: 0,
  class: "spinner-border ms-3 mt-4"
}
const _hoisted_10 = { class: "px-0 py-2" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user circle",
  style: {"background":"#f4f4f4","color":"#7a7a7a","size":"48px"}
}, null, -1)
const _hoisted_14 = { class: "d-flex flex-column me-auto" }
const _hoisted_15 = { class: "ms-3 mb-1" }
const _hoisted_16 = { class: "ms-3 smallText" }

import { onMounted, onUnmounted, ref } from "vue";
import { Ref } from "vue";
import TableView from "@/components/TableView.vue";
import { useFirebaseStore } from "@/stores/firebase-store";
import CreateAdminModal from "@/views/administrators/CreateAdminModal.vue";


const __default__ = {
  name: "AdministratorsView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let modalVisible: Ref<boolean> = ref(false);

const firebaseStore = useFirebaseStore();

onMounted(() => {
  firebaseStore.subscribeAdministrators();
});

onUnmounted(() => {
  firebaseStore.unsubscribeAdministrators();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-lg btn-floating",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(modalVisible) //@ts-ignore
 ? modalVisible.value = true : modalVisible = true))
            }, _hoisted_7)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_unref(firebaseStore).loadingAdministrators)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
          : (_openBlock(), _createBlock(TableView, {
              key: 1,
              borderless: true
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firebaseStore).administrators, (administrator) => {
                  return (_openBlock(), _createElementBlock("tr", { key: administrator }, [
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(administrator.displayName), 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(administrator.emailAddress), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(CreateAdminModal, {
      "is-visible": _unref(modalVisible),
      onHideModal: _cache[1] || (_cache[1] = ($event: any) => (_isRef(modalVisible) //@ts-ignore
 ? modalVisible.value = false : modalVisible = false))
    }, null, 8, ["is-visible"])
  ], 64))
}
}

})